import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { ExpeditionStatusEnum } from '@api/ringil-api.v2.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import SvgStateinfo from '@components/ringil3/icons/Stateinfo.tsx';

interface ComponentProps {
  expeditionState: ExpeditionStatusEnum;
  cancellationReasonCode?: string;
  dataTestId?: string;
}

const StateTag: React.FC<ComponentProps> = ({ expeditionState, cancellationReasonCode, dataTestId }) => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <ButtonTag
        label={tr('StateTag.state', 'Stav')}
        value={
          tr(expeditionState, expeditionState) +
          (cancellationReasonCode ? ' (' + tr('CancellationReasonCode.' + cancellationReasonCode, cancellationReasonCode) + ')' : '')
        }
        icon={<SvgStateinfo />}
        readonly={true}
        dataTestId={dataTestId}
      />
    </>
  );
};

export default StateTag;
